module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kaisten_AG-7924fb8e9ccfe52e15b2252a3d500839.svg";